import { Link, useLocation } from "react-router-dom";
import { Logo } from "../logo/logo";
import {
  SidebarMenuNavigationItemModel,
  SidebarMenuNavigationCollapseItemModel,
} from "./sidebarMenuModel";

import tiresets from "./assets/tiresets.svg";
import tires from "./assets/tire.svg";
import request from "./assets/request.svg";
import invoice from "./assets/invoice.svg";
import warehouse from "./assets/warehouse.svg";
import path from "./assets/path.svg";
import position from "./assets/position.svg";
import storage from "./assets/storage.svg";
import planning from "./assets/planning.svg";
import dailyPlanning from "./assets/dailyPlanning.svg";
import truck from "./assets/truck.svg";
import routes from "./assets/route.svg";
import slip from "./assets/slip.svg";
import settings from "./assets/settings.svg";
import log from "./assets/log.svg";
import events from "./assets/notifcation.svg";

import person from "./assets/person.svg";
import polygon from "./assets/polygon.svg";

import { useState } from "react";
import { Collapse } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../hooks/useTypedSelector";

const checkIfSelected = (to: string, pathname: string) => {
  return pathname === to || (to !== "/" && pathname.includes(to));
};

const checkIfSelectedMulti = (to: string[], pathname: string) => {
  return to.some((t) => checkIfSelected(t, pathname));
};

const SidebarMenuNavigationItem = ({
  to,
  label,
  icon,
  show = true,
  count,
}: SidebarMenuNavigationItemModel) => {
  const { pathname } = useLocation();
  const selected = checkIfSelected(to, pathname);

  if (!show) {
    return <></>;
  }

  return (
    <Link
      to={to}
      className={
        "nav-link sidebar-menu-navigation-link" + (selected ? " selected" : "")
      }
    >
      {icon ? (
        <span className="sidebar-menu-navigation-link-icon">
          <img src={icon} alt={label} />
        </span>
      ) : (
        <span className="sidebar-menu-navigation-link-icon-placeholder" />
      )}
      {label}
      {count !== undefined && count > 0 && (
        <span className="sidebar-menu-navigation-link-count">{count}</span>
      )}
    </Link>
  );
};

const SidebarMenuNavigationCollapseItem = ({
  label,
  icon,
  children,
  selected = false,
  show = true,
}: SidebarMenuNavigationCollapseItemModel) => {
  const [open, setOpen] = useState(selected);

  const id = "collapse" + label;

  if (!show) {
    return <>{children}</>;
  }

  return (
    <>
      <a
        href="#"
        onClick={(event) => {
          event.preventDefault();
          setOpen(!open);
        }}
        className={
          "nav-link sidebar-menu-navigation-link" +
          (selected ? " selected" : "")
        }
        aria-controls={id}
        aria-expanded={open}
      >
        {icon ? (
          <span className="sidebar-menu-navigation-link-icon">
            <img src={icon} alt={label} />
          </span>
        ) : (
          <span className="sidebar-menu-navigation-link-icon-placeholder" />
        )}
        {label}
        <span className="sidebar-menu-navigation-link-dropdown-icon">
          <img src={polygon} alt={label} />
        </span>
      </a>
      <Collapse in={open}>
        <div id={id} className="sidebar-menu-navigation-collapse">
          {children}
        </div>
      </Collapse>
    </>
  );
};

export const SidebarMenu = ({
  isMobile,
  open,
  setOpen,
  updateDOM,
}: {
  isMobile: boolean;
  open: boolean;
  setOpen: (open: boolean) => void;
  updateDOM: () => void;
}) => {
  const { t } = useTranslation("common");
  const currentUser = useAppSelector((state) => state.auth.user);
  const { newEventsCount } = useAppSelector((state) => state.eventMutate);
  const { pathname } = useLocation();

  return (
    <div className="sidebar-menu">
      <div className="sidebar-menu-logo-wrapper d-flex justify-content-evenly">
        <Logo />
        {!isMobile && (
          <button
            className="navbar-toggler btn-outline-light"
            type="button"
            onClick={() => {
              setOpen(!open);
              updateDOM();
            }}
            aria-controls="sidebar"
            aria-expanded={open}
          >
            <span className="navbar-toggler-icon-light"></span>
          </button>
        )}
      </div>

      <nav className="nav sidebar-menu-navigation">
        <SidebarMenuNavigationItem
          to="/dashboard"
          label={t("Dashboard")}
          icon={log}
          show={
            currentUser.role === "super-admin" ||
            currentUser.role === "dealer-employee"
          }
        />
        <SidebarMenuNavigationItem
          to="/tire-sets"
          label={t("Tire sets")}
          icon={tiresets}
        />
        <SidebarMenuNavigationItem to="/cars" label={t("Cars")} icon={tires} />
        <SidebarMenuNavigationItem
          to="/requests"
          label={t("Verzoeken")}
          icon={request}
        />
        <SidebarMenuNavigationItem
          to="/invoices"
          label={t("Invoices")}
          icon={invoice}
          show={
            currentUser.role !== "dbh-driver" &&
            currentUser.role !== "dbh-order-picker" &&
            currentUser.role !== "dealer-employee" &&
            currentUser.role !== "dbh-employee"
          }
        />
        <SidebarMenuNavigationItem
          to="/relations"
          label={t("Dealers")}
          icon={person}
          show={
            currentUser.role !== "dbh-driver" &&
            currentUser.role !== "dbh-order-picker" &&
            currentUser.role !== "dbh-employee"
          }
        />
        <SidebarMenuNavigationCollapseItem
          label={t("Storage")}
          icon={storage}
          selected={checkIfSelectedMulti(
            ["/warehouses", "/paths", "/positions", "/shelvingUnits"],
            pathname,
          )}
          show={
            currentUser.role === "super-admin" ||
            currentUser.role === "dbh-manager"
          }
        >
          <SidebarMenuNavigationItem
            to="/warehouses"
            label={t("Warehouses")}
            icon={warehouse}
            show={
              currentUser.role === "super-admin" ||
              currentUser.role === "dbh-manager"
            }
          />
          <SidebarMenuNavigationItem
            to="/paths"
            label={t("Paths")}
            icon={path}
            show={
              currentUser.role === "super-admin" ||
              currentUser.role === "dbh-manager"
            }
          />
          <SidebarMenuNavigationItem
            to="/shelvingUnits"
            label={t("Shelving units")}
            icon={path}
            show={
              currentUser.role === "super-admin" ||
              currentUser.role === "dbh-manager"
            }
          />
          <SidebarMenuNavigationItem
            to="/positions"
            label={t("Positions")}
            icon={position}
            show={
              currentUser.role === "super-admin" ||
              currentUser.role === "dbh-manager"
            }
          />
        </SidebarMenuNavigationCollapseItem>
        <SidebarMenuNavigationItem
          to="/users"
          label={t("Users")}
          icon={person}
          show={
            currentUser.role === "super-admin" ||
            currentUser.role === "dbh-manager"
          }
        />

        {currentUser.role !== "dealer-employee" ? (
          <>
            <SidebarMenuNavigationCollapseItem
              label={t("Planning")}
              icon={planning}
              selected={checkIfSelectedMulti(
                [
                  "/planning/daily-planning",
                  "/planning/default-routes",
                  "/trucks",
                  "/truck",
                  "/routes",
                  "/packing-slips",
                  "/packing-slip",
                  "/packing-lists",
                  "/planning/settings",
                  "/planning/default-routes",
                  "/planning/default-route",
                ],
                pathname,
              )}
            >
              <SidebarMenuNavigationItem
                to="/planning/daily-planning"
                label={t("Daily planning")}
                icon={dailyPlanning}
                show={
                  currentUser.role === "super-admin" ||
                  currentUser.role === "dbh-manager"
                }
              />
              <SidebarMenuNavigationItem
                to="/planning/default-routes"
                label={t("Default routes")}
                icon={tires}
                show={
                  currentUser.role === "super-admin" ||
                  currentUser.role === "dbh-manager"
                }
              />
              <SidebarMenuNavigationItem
                to="/trucks"
                label={t("Trucks")}
                icon={truck}
                show={
                  currentUser.role === "super-admin" ||
                  currentUser.role === "dbh-manager"
                }
              />

              <SidebarMenuNavigationItem
                to="/routes"
                label={t("Routes")}
                icon={routes}
                show={
                  currentUser.role === "super-admin" ||
                  currentUser.role === "dbh-manager"
                }
              />
              <SidebarMenuNavigationItem
                to="/packing-slips"
                label={t("Packing slips")}
                icon={slip}
              />
              <SidebarMenuNavigationItem
                to="/packing-lists"
                label={t("Packing lists")}
                icon={slip}
                show={
                  currentUser.role === "super-admin" ||
                  currentUser.role === "dbh-manager"
                }
              />
              <SidebarMenuNavigationItem
                to="/planning/settings"
                label={t("Settings")}
                icon={settings}
                show={
                  currentUser.role === "super-admin" ||
                  currentUser.role === "dbh-manager"
                }
              />
            </SidebarMenuNavigationCollapseItem>
          </>
        ) : (
          <SidebarMenuNavigationItem
            to="/packing-slips"
            label={t("Packing slips")}
            icon={slip}
          />
        )}

        <SidebarMenuNavigationItem
          to={"/logs"}
          label={t("Logs")}
          icon={log}
          show={
            currentUser.role === "super-admin" ||
            currentUser.role === "dbh-manager"
          }
        />

        <SidebarMenuNavigationItem
          to={"/events"}
          label={t("Events")}
          icon={events}
          count={newEventsCount}
          show={
            currentUser.role === "super-admin" ||
            currentUser.role === "dbh-manager"
          }
        />
      </nav>
    </div>
  );
};
